/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data: {
        currentIndex: 0,
        timer: null,
        debounceTimer: null,
        carouselLength: 0,
        autoPlayDuration: 4000  // Default autoplay duration
    },
    computed: {
        getCarouselItemClasses() {
            return (index) => {
                let prev1 = (this.currentIndex - 1 +  this.carouselLength) % this.carouselLength;
                let prev2 = (this.currentIndex - 2 +  this.carouselLength) % this.carouselLength;
                let next1 = (this.currentIndex + 1) % this.carouselLength;
                let next2 = (this.currentIndex + 2) % this.carouselLength;
                return {
                    'active': index === this.currentIndex,
                    'prev': index === prev1,
                    'prev-1': this.carouselLength >= 5 && index === prev2,
                    'next': index === next1,
                    'next-1': this.carouselLength >= 5 && index === next2
                };
            };
        }
    },
    mounted() {
        this.parseCarouselData();
        qkUpdateLazyLoad()
        this.startAutoPlay();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    methods: {
        startAutoPlay() {
            this.timer = setInterval(() => {
                this.next();
            }, this.autoPlayDuration); // 每隔4秒自动切换
        },
        prev() {
            this.currentIndex = (this.currentIndex - 1 + this.carouselLength) % this.carouselLength;
        },
        next() {
            this.currentIndex = (this.currentIndex + 1) % this.carouselLength;
        },
        click(index) {
            this.currentIndex = index;
        },
        handleVisibilityChange() {
            if (document.hidden) {
                clearInterval(this.timer); // 在页面不可见时暂停自动播放
            } else {
                this.startAutoPlay(); // 在页面可见时恢复自动播放
            }
        },
        handleMouseEnter() {
            clearInterval(this.timer); // 当鼠标悬停在图片或点上时暂停自动播放
        },
        handleMouseLeave() {
            this.startAutoPlay(); // 使用防抖函数处理恢复自动播放
        },
        parseCarouselData() {
            const carouselContainer = this.$refs.carouselContainer;
            if (carouselContainer) {
                const carouselData = JSON.parse(carouselContainer.getAttribute('carousel-data'));
                this.carouselLength = carouselData.length;
                this.autoPlayDuration = carouselData.autoPlay || 4000; 
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.timer); // 在组件销毁前清除定时器
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
};
